<template>
  <v-card
      :elevation="selectedPackage === plan.id ? 16:0"
      class="ma-4 HoverReaction plan-card"
      :disabled="(selectedPackage !== plan.id && page === 1 )"
      @click="OnPlanSelect(plan.id)"
      :color="(selectedPackage === plan.id && page === 1 ) ? 'primary':'white'"
      :dark="(selectedPackage === plan.id && page === 1 )"

      v-bind:class="{ 'SelectedBorder': selectedPackage === plan.id}"
      width="300"
      :height="selectedPackage === plan.id ? '':'256'"
      hover
      ripple>
    <v-card-text>
      <!-- <v-row v-if="selectedPackage === plan.id" no-gutters justify="center" class="SmallFont mb-4">
        You Have Selected
      </v-row> -->
      <v-row
          class="font-weight-black text-h4 CapFirst"
          v-bind:class="{ 'MoneyColor' :selectedPackage !== plan.id, 'SelectedMoneyColor' :selectedPackage === plan.id }"
          no-gutters
          justify="center">{{ plan.name }}</v-row>
      <!--<v-row no-gutters justify="center" class="SmallFont">
        {{ plan.details }}
      </v-row>-->
      <v-row
          align="end"
          v-bind:class="{ 'MoneyColor' :selectedPackage !== plan.id, 'WhiteColor' : (selectedPackage === plan.id && page === 1 ) }"
          no-gutters justify="center" class="font-weight-black text-h5 mt-4">
        {{ MoneyFormat(plan.package_details[0].price) }}
      </v-row>
      <v-row no-gutters justify="center" class="SmallFont mb-4">
        Per Person
      </v-row>

      <div v-if="page === 0 && selectedPackage === plan.id">
      <v-row :key="i" v-for="(feature,i) in plan.package_additionals" no-gutters justify="center" class="SmallFont mb-3">
        <v-col cols="2">
          <v-icon>mdi-check</v-icon>
        </v-col>
        <v-col class="text-start">
          <span class="text-start">{{ feature.value }}</span>
        </v-col>
      </v-row>
      </div>
    </v-card-text>
    <v-alert elevation="0" class="rounded-0" color="#D6AF44" dark v-if="selectedPackage === plan.id">
      <v-card-subtitle class="pb-0 font-weight-black text-h6">Total</v-card-subtitle>
      <v-card-title class="mt-0 pt-0">
        <v-row no-gutters justify="center">
          <div class="font-weight-black text--white text-start text-h5">
            {{ total }}
          </div>
        </v-row>
      </v-card-title>
    </v-alert>

    <v-row no-gutters justify="center" v-if="selectedPackage === plan.id && page === 0">
      <v-btn @click="NextPage" large class="mt-4 mb-4 w-100 select-button" light color="#07614D" dark>Select</v-btn>
    </v-row>

    <v-row no-gutters justify="center" v-if="selectedPackage === plan.id && page === 1">
      <v-btn @click="BackPage" large class="mt-4 mb-4 w-100 select-button" light color="white">Unselect</v-btn>
    </v-row>
  </v-card>
</template>

<script>
export default {
  name: "PlanCard",
  props:{
    total: String,
    actuallySelected: Number,
    selectedPackage: Number,
    plan: Object,
    page: Number
  },
  methods:{
    NextPage(){
      this.$emit('nextpage')
    },
    BackPage(){
      this.$emit('backpage')
    },
    MoneyFormat(value){
      return Intl.NumberFormat('en-US', { style: 'currency', currency: 'LKR' }).format(value);
    },
    OnPlanSelect(id){
      if(this.page === 0){
        this.$emit('OnPlanSelect',id);
      }
    }
  }
}
</script>

<style scoped>
.CapFirst{
  text-transform: capitalize;
}

.SmallFont{
  font-size: 14px;
}

.WhiteColor{
  color: white;
}

.v-card .SelectedBorder {
  border: 2px solid #85BBC4 !important
}

.v-card {
  border: 2px solid #85BBC4 !important
}

.HoverReaction{
  transition: 256ms;
}


.HoverReaction:hover{
  transform: scale(1.03);
}

.SelectedMoneyColor{
  color: #D6AF44;
}

.MoneyColor{
  color: #1A4F57;
}


.plan-card .MoneyColor {
      font-size: 26px !important;
}

.plan-card .SelectedMoneyColor {
      font-size: 26px !important;
}

.select-button {
  width: 80%;

}
</style>
